import _extends from "@babel/runtime/helpers/extends";
import { CloseIcon as LodestarCloseIcon } from "@smartsheet/lodestar-icons";
import { themed } from "@smartsheet/sds-theme-internal";
import { CloseIcon } from "@smartsheet/ursa-icons";
import React, { forwardRef } from "react";
import { useTheme } from "../../../theme/utils/useTheme";
import { BannerDismissButtonStyled } from "../styled/BannerDismissButtonStyled";
export const closeIcon = themed({
  icon: {
    "lodestar-light": /*#__PURE__*/React.createElement(LodestarCloseIcon, {
      size: "small",
      color: "currentColor"
    }),
    "ursa-light": /*#__PURE__*/React.createElement(CloseIcon, {
      size: 24,
      color: "currentColor"
    })
  }
});
export const BannerDismissButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(BannerDismissButtonStyled, _extends({
    tabIndex: 0,
    ref: ref
  }, props), closeIcon.icon(themeMode));
});
BannerDismissButton.displayName = "BannerDismissButton";
//# sourceMappingURL=BannerDismissButton.js.map